/** Keeps the shared tooltip inside the viewport without changing its mouse anchor. */
export class TooltipHost {
    private readonly element: HTMLElement;
    private readonly onResize = (): void => this.position();

    constructor(element: HTMLElement) {
        this.element = element;
    }

    public Show(): void {
        this.position();
        window.addEventListener('resize', this.onResize);
    }

    public Hide(): void {
        window.removeEventListener('resize', this.onResize);
    }

    public Dispose(): void {
        this.Hide();
    }

    private position(): void {
        const left = Number.parseFloat(this.element.style.left);
        const top = Number.parseFloat(this.element.style.top);
        const { width, height } = this.element.getBoundingClientRect();
        const fitsHorizontally = left >= 0 && left + width <= window.innerWidth;
        const fitsVertically = top >= 0 && top + height <= window.innerHeight;

        // Preserve the original mouse anchor whenever the tooltip already fits, including after an edge hover.
        if (fitsHorizontally === true && fitsVertically === true) {
            this.element.style.removeProperty('transform');
            return;
        }

        const margin = 8;
        const maxLeft = Math.max(margin, window.innerWidth - width - margin);
        const maxTop = Math.max(margin, window.innerHeight - height - margin);
        const flippedLeft = left > maxLeft ? left - width - 12 : left;
        // The supplied top already includes the trigger's 12px cursor offset.
        const flippedTop = top > maxTop ? top - height - 24 : top;
        const boundedLeft = fitsHorizontally === true ? left : Math.max(margin, Math.min(flippedLeft, maxLeft));
        const boundedTop = fitsVertically === true ? top : Math.max(margin, Math.min(flippedTop, maxTop));

        // Keep Blazor's inline anchor intact so repeated hovers and resize can reposition it.
        this.element.style.transform = `translate(${boundedLeft - left}px, ${boundedTop - top}px)`;
    }
}

window['InitTooltipHost'] = (element: HTMLElement): TooltipHost => new TooltipHost(element);
